module.exports = __webpack_public_path__ + "static/media/1.c216f4a1.png";